export const ForgetPassConfig = {
  fields: [
    {
      name: 'email',
      placeholder: 'Email',
      type: 'text'
    }
  ]
};

export default ForgetPassConfig;



// WEBPACK FOOTER //
// ./src/actions/auth/configs/ForgetPassConfig.js